// istanbul ignore file

type AgencyKeyPickupLocation = {
    keyLocationId: number;
    streetAddressId: number;
    fullAddress: string;
    propertyManagerId: string | null;
    isAgencyAddress: boolean;
};

type PropertyKeyPickupLocation = {
    keyLocationId: string | null;
    streetAddressId: number;
    fullAddress: string;
    addressLine1: string;
    addressLine2: string;
    isUseKeyLocationFromPM: boolean;
};

enum KeyAvailableType {
    Yes = 'YES',
    No = 'NO'
}

export {
    AgencyKeyPickupLocation,
    KeyAvailableType,
    PropertyKeyPickupLocation,
};
